import { useAuth } from "../../context/AuthContext";

export const Error: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6 text-center">
        <div className="text-red-500 text-6xl mb-4">🚫</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Error</h1>
        <p className="text-gray-600 mb-4">
          Ocurrió un error al ejecutar la acción, por favor comunicacte con soporte.
        </p>

        <div className="space-y-2">
          <button
            onClick={() => window.history.back()}
            className="w-full bg-gray-600 text-white py-2 px-4 rounded hover:bg-gray-700"
          >
            Volver
          </button>
          <button
            onClick={logout}
            className="w-full border border-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-50"
          >
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};